export function parseJson(data: string): any[] {
    return Array.from(JSON.parse(data));
}
